// extracted by mini-css-extract-plugin
export default {"animatedBadge":"DashboardMenu_animatedBadge__WDek6","brand_red_pulse":"DashboardMenu_brand_red_pulse__qPiix","spin":"DashboardMenu_spin__SeeIX"};